const PRE_FINANCE_YEAR_START = 2021;

/** Years from current year + 1 down to 2021 (inclusive). */
export const getPreFinanceYearOptions = (referenceDate = new Date()) => {
  const maxYear = referenceDate.getFullYear() + 1;
  const length = Math.max(0, maxYear - PRE_FINANCE_YEAR_START + 1);

  return Array.from({ length }, (_, index) => maxYear - index);
};
